import { arrayOf, number, shape, string } from "prop-types";

import CodeItem from "web/Components/Common/CodeItem";

const CustomerCodeListListItemMobile = ({
  link,
  name,
  image,
  expirationDate,
  userUsed,
  itemId,
  options,
  codeDetails,
  supplierId,
  dataT1,
  productStatus,
  producSuperOptions,
  orderStatusCode,
  paymentStatus,
}) => {
  return (
    <>
      <CodeItem
        link={link}
        name={name}
        image={image}
        supplierId={supplierId}
        expirationDate={expirationDate}
        userUsed={userUsed}
        itemId={itemId}
        options={options}
        paymentStatus={paymentStatus}
        codeDetails={codeDetails}
        dataT1={dataT1}
        productStatus={productStatus}
        producSuperOptions={producSuperOptions}
        orderStatusCode={orderStatusCode}
      />
    </>
  );
};

CustomerCodeListListItemMobile.propTypes = {
  link: string.isRequired,
  name: string.isRequired,
  image: string,
  expirationDate: string.isRequired,
  userUsed: number.isRequired,
  itemId: number.isRequired,
  options: arrayOf(shape({})).isRequired,
  codeDetails: shape({}).isRequired,
  supplierId: string.isRequired,
  dataT1: string.isRequired,
  productStatus: string.isRequired,
  producSuperOptions: shape({}),
  orderStatusCode: string,
  paymentStatus: string,
};

CustomerCodeListListItemMobile.defaultProps = {
  image: "",
  producSuperOptions: {},
  orderStatusCode: "",
  paymentStatus: "",
};

export default CustomerCodeListListItemMobile;
